<template>
<div>
  <div class="page-header">
    <div class="add-item d-flex">
      <div class="page-title">
        <h6>{{ $t('edit_setting') }}</h6>
      </div>
    </div>
    <ul class="table-top-head">
      <li>
        <div class="page-btn">
          <router-link to="/invoice/setting/list" class="btn btn-added">
            <span>Back</span>
          </router-link>
        </div>
      </li>
      <li>
        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>
      </li>
    </ul>
  </div>

  <form @submit.prevent="updateSetting" enctype="multipart/form-data">
    <div class="row">
        <!-- LEFT SIDE -->
        <div class="col-lg-8">
          <!-- BUSINESS INFO -->
          <div class="card custom-card mb-4">
            <div class="card-body">
              <div class="section-title">
                <h5>Business Information</h5>
              </div>
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">
                    {{ $t("business_name") }}
                  </label>
                  <input
                    type="text"
                    class="form-control modern-input"
                    v-model="setting.business_name"
                  >
                  <small class="text-danger">
                    {{ errors.business_name }}
                  </small>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label">
                    {{ $t("business_phone") }}
                  </label>
                  <input
                    type="text"
                    class="form-control modern-input"
                    v-model="setting.business_phone"
                  >
                  <small class="text-danger">
                    {{ errors.business_phone }}
                  </small>
                </div>

                <div class="col-12 mb-3">
                  <label class="form-label">
                    {{ $t("business_address") }}
                  </label>
                  <input
                    type="text"
                    class="form-control modern-input"
                    v-model="setting.business_address"
                  >
                  <small class="text-danger">
                    {{ errors.business_address }}
                  </small>
                </div>
              </div>
            </div>
          </div>

          <!-- TAX INFO -->
          <div class="card custom-card mb-4">
            <div class="card-body">
              <div class="section-title">
                <h5>Tax Information</h5>
              </div>

              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">TIN</label>
                  <input
                    type="text"
                    class="form-control modern-input"
                    v-model="setting.tin"
                  >
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">BIN</label>
                  <input
                    type="text"
                    class="form-control modern-input"
                    v-model="setting.bin"
                  >
                </div>
              </div>
            </div>
          </div>

          <!-- MESSAGE -->
          <div class="card custom-card mb-4">
            <div class="card-body">
              <div class="section-title">
                <h5>Invoice Messages</h5>
              </div>

              <div class="mb-3">
                <label class="form-label">
                  {{ $t("header_message") }}
                </label>
                <input
                  type="text"
                  class="form-control modern-input"
                  v-model="setting.header_message"
                >
              </div>
              <div>
                <label class="form-label">
                  {{ $t("footer_message") }}
                </label>
                <input
                  type="text"
                  class="form-control modern-input"
                  v-model="setting.footer_message"
                >
              </div>
            </div>
          </div>
        </div>

        <!-- RIGHT SIDE -->
        <div class="col-lg-4">
          <!-- LOGO -->
          <div class="card custom-card mb-4">
            <div class="card-body">
              <div class="section-title">
                <h5>Upload Invoice Logo</h5>
              </div>

              <div class="logo-upload-wrapper">
                <div class="logo-preview-box">
                  <img
                    v-if="logoPreview"
                    :src="logoPreview"
                    class="preview-image"
                  >

                  <div v-else class="empty-logo">
                    <i class="ti ti-photo"></i>
                    <span>Upload Logo</span>
                  </div>

                  <button
                    v-if="logoPreview"
                    type="button"
                    class="remove-logo-btn"
                    @click="removeLogo"
                  >
                    <i class="ti ti-x"></i>
                  </button>
                </div>
                <input
                  type="file"
                  accept="image/*"
                  class="form-control modern-input mt-3"
                  @change="handleLogoUpload"
                >
              </div>
            </div>
          </div>

          <!-- SETTINGS -->
          <div class="card custom-card">
            <div class="card-body">
              <div class="section-title">
                <h5>Display Settings</h5>
              </div>

              <div class="setting-item">
                <span>Show Logo</span>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="setting.show_logo"
                  >
                </div>
              </div>

              <div class="setting-item">
                <span>Show TIN</span>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="setting.show_tin"
                  >
                </div>
              </div>

              <div class="setting-item">
                <span>Show BIN</span>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="setting.show_bin"
                  >
                </div>
              </div>

              <div class="setting-item border-0 pb-0">
                <span>Powered By</span>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="setting.powered_by"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ACTION BUTTON -->
      <div class="text-end mt-0">
        <button
          type="button"
          class="btn btn-light border px-4 py-2 me-2 rounded-pill"
          @click="cancelForm"
        >
          {{ $t('cancel') }}
        </button>

        <button
          type="submit"
          class="btn btn-primary px-4 py-2 rounded-pill"
        >
          {{ $t('submit') }}
        </button>
      </div>
  </form>
</div>
</template>

<script>
import apiUrls from "@/urls";
import Vue3Datepicker from 'vue3-datepicker';
import VueSelect2 from "vue3-select2-component";
import {useToast} from "vue-toastification";

export default {
  components: {
    Vue3Datepicker,
    VueSelect2,
  },

  data() {
    return {
      setting: {
        business_name: '',
        business_address: '',
        business_phone: '',
        tin: '',
        show_tin: true,
        bin: '',
        show_bin: true,
        header_message: '',
        footer_message: '',
        logo: null,
        show_logo: true,
        powered_by: true,

      },
      logoPreview: null,
      existingLogo: null,
      errors: {},
      errorMessage: "",
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  mounted() {
    this.fetchSetting();
  },

  methods: {
    async fetchSetting() {
      try {
        const id = this.$route.params.id;
        const response = await this.$axios.get(`${apiUrls.invoice_setting.get}${id}/`);
        this.setting = response.data;

        if (response.data.logo) {
          this.existingLogo = response.data.logo;
          this.logoPreview = response.data.logo;
        }
      } catch (error) {
        this.$toast.error(this.$t('error_fetching_settings'));
      }
    },

    handleLogoUpload(event) {
      const file = event.target.files[0];

      if (!file) return;
      this.setting.logo = file;

      if (this.logoPreview) {
        URL.revokeObjectURL(this.logoPreview);
      }
      this.logoPreview = URL.createObjectURL(file);
    },

    removeLogo() {
      this.setting.logo = null;
      this.logoPreview = null;
      this.existingLogo = null;
    },

    async updateSetting() {
      // Frontend validation before making API call
        this.errors = {};
        if (!this.setting.business_name) this.errors.business_name = this.$t('error.required');
        if (!this.setting.business_address) this.errors.business_address = this.$t('error.required');
        if (!this.setting.header_message) this.errors.header_message = this.$t('error.required');
        if (!this.setting.footer_message) this.errors.footer_message = this.$t('error.required');

        if (Object.keys(this.errors).length > 0) {
          return;
      }

      try {
        const formData = new FormData();

        formData.append('business_name', this.setting.business_name);
        formData.append('business_phone', this.setting.business_phone);
        formData.append('business_address', this.setting.business_address);
        formData.append('tin', this.setting.tin || '');
        formData.append('show_tin', this.setting.show_tin);
        formData.append('bin', this.setting.bin || '');
        formData.append('show_bin', this.setting.show_bin);
        formData.append('header_message', this.setting.header_message || '');
        formData.append('footer_message', this.setting.footer_message || '');
        formData.append('show_logo', this.setting.show_logo);
        formData.append('powered_by', this.setting.powered_by);

        // Only append if new file selected
        if (this.setting.logo instanceof File) {
          formData.append('logo', this.setting.logo);
        }

        await this.$axios.put(
          apiUrls.invoice_setting.update(this.$route.params.id),
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );

        this.toast.success('invoice setting successfully updated!')

        // Redirect only after successful response
        this.$router.push('/invoice/setting/list');

        // Emit event to update parent component
        this.$emit("create_success");

        this.resetForm();
      } catch (error) {
        if (error.response?.data?.error) {
          this.errorMessage = error.response.data.error;
        }

        // Handle field-specific errors dynamically
        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors;
        }
      }
    },

    cancelForm() {
        this.$router.push('/invoice/setting/list');
      },

    resetForm() {
      // Reset form fields and errors
      this.setting = {
        business_name: '',
        business_address: '',
        business_phone: '',
        tin: '',
        show_tin: true,
        bin: '',
        show_bin: true,
        header_message: '',
        footer_message: '',
        logo: null,
        show_logo: true,
        powered_by: true,
      };
      this.errors = {};
      this.errorMessage = "";
    }
  },
};
</script>
